import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { api } from "@/lib/api";

const CATEGORIES = [
  { key: "cashless", label: "Cashless Insurance" },
  { key: "corporate", label: "Corporate Tie-ups" },
  { key: "govt", label: "Government Health Schemes" },
  { key: "tpa", label: "TPAs" },
];

export default function Insurance() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/insurance").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="insurance-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-green">Insurance &amp; Cashless</span>
          <h1 className="text-4xl sm:text-5xl font-bold">Hassle-free billing, every step.</h1>
          <p className="text-slate-600 mt-3 max-w-2xl">We're empanelled with all leading insurers, corporates, government schemes and TPAs.</p>
        </div>
      </section>
      <section className="container-x py-10 space-y-10">
        {CATEGORIES.map((c) => (
          <div key={c.key} data-testid={`ins-cat-${c.key}`}>
            <h2 className="text-2xl font-bold mb-4 text-brand-purple">{c.label}</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {items.filter((i) => i.category === c.key).map((i) => (
                <div key={i.id} className="card-clean p-5 text-center" data-testid={`ins-${i.id}`}>
                  <div className="h-12 w-12 mx-auto rounded-lg bg-brand-purple/10 text-brand-purple grid place-items-center mb-2"><Building2 className="h-6 w-6" /></div>
                  <div className="font-semibold text-sm">{i.name}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
